import { defineComponent as _defineComponent } from 'vue'
import { getDateFormatted, getTimeFormatted12Hours } from '@/services/date'
import { IEventEdit } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventRefundPolicy',
  props: {
    eventData: null
  },
  setup(__props: any) {



return { __sfc: true,getDateFormatted, getTimeFormatted12Hours }
}

})